import FeaturePageTemplate from "@/components/FeaturePageTemplate";

export default function AiCopilotPage() {
  return (
    <FeaturePageTemplate
      slug="copilot"
      accent="#0891B2"
      badge="For your human team · Now available"
      title="Employee Copilot"
      tagline="Whispers next-best-action to your human team"
      subtitle="During live human-managed conversations, the Copilot suggests grounded reply drafts, next best actions, policy reminders, and sentiment cues — private to the agent. Never sends anything on its own."
      primaryCta={{ label: "Open Copilot", to: "/copilot" }}
      secondaryCta={{ label: "Explore Voice hub", to: "/voice" }}
      brandStripe="Human-in-the-loop. Every suggestion is optional — the agent decides what ships."
      flow={[
        { n: "1", title: "Listen",    desc: "Copilot follows the current live conversation in real time." },
        { n: "2", title: "Suggest",   desc: "Grounded reply draft with citations to your knowledge vault." },
        { n: "3", title: "Advise",    desc: "Next best action, policy reminders, sentiment cue, escalation flag." },
        { n: "4", title: "Decide",    desc: "Agent accepts, edits, or ignores — the AI never sends on its own." },
        { n: "5", title: "Log",       desc: "PII-redacted event log for coaching and quality control." },
      ]}
      capabilities={[
        { icon: "MessageSquare", title: "Grounded reply drafts", desc: "Cites your approved articles. Hallucination score attached." },
        { icon: "Compass",       title: "Next-best-action",       desc: "Book demo · send quote · escalate · request info — ranked." },
        { icon: "AlertTriangle", title: "Policy reminders",       desc: "Restricted topics, allowed CTAs, and compliance nudges surface inline." },
        { icon: "Smile",         title: "Sentiment cues",         desc: "Real-time customer mood indicator + auto-escalate on risk keywords." },
        { icon: "Link2",         title: "Citations",              desc: "Every suggestion links back to the source article and last-reviewed date." },
        { icon: "FileText",      title: "Coaching log",           desc: "Aggregate suggestions taken vs ignored to spot training gaps." },
      ]}
      safetyBullets={[
        ["Never autonomous",    "Copilot never sends messages. The agent is always in control."],
        ["PII redacted logs",   "Emails, phones, cards, SSN patterns masked in stored events."],
        ["Consent-aware",       "Respects the customer's data-use consent scope."],
        ["Full audit trail",    "Every suggestion is timestamped with agent, conversation, and outcome."],
      ]}
      closingHeadline="Make every agent your best agent."
      closingSubtitle="Ground truth on tap, sentiment on-screen, and the next best step one keystroke away."
      testIdPrefix="ai-copilot-page"
    />
  );
}
